import { action, makeObservable } from 'mobx';
import { Filtro } from './Filtro';

export default class FiltroAutorAnalise extends Filtro {
    tipo = 'selecao';
    exibicao = 'select';
    selecaoMultipla = true;

    /**
     * Opção para quando o dado for inexistente quando deveria ter a informação
     */
    static opcaoSemInformacao = '(Autor não registrado)';

    /**
     * Opção para quando não existir registro de análise
     */
    static opcaoSemValor = null;

    get label() {
        return 'Autor da análise';
    }

    constructor(props) {
        super(props);

        makeObservable(this, {
            getValorOpcao: action
        });
    }

    getValorOpcao(registro) {
        if (registro?.informacaoProcessoSalaSessao?.tipoValidacao) {
            if (!registro.informacaoProcessoSalaSessao.nomeUsuarioValidacao?.trim()) {
                return FiltroAutorAnalise.opcaoSemInformacao;
            }

            return registro.informacaoProcessoSalaSessao.nomeUsuarioValidacao.trim().toUpperCase();
        }

        return FiltroAutorAnalise.opcaoSemValor;
    }
}
